/// <reference types="vite/client" />
import { registerLocaleModules, type Messages } from '@fondationcss/sdk'

// Each area keeps its texts in `<area>/fr-CA.json` and `<area>/en-CA.json`; this registers them all.
registerLocaleModules('fr-CA', import.meta.glob<Messages>('./**/fr-CA.json', { eager: true, import: 'default' }))
registerLocaleModules('en-CA', import.meta.glob<Messages>('./**/en-CA.json', { eager: true, import: 'default' }))
